import { render, staticRenderFns } from "./PopupNotificationGlobal.vue?vue&type=template&id=61c8ae12&"
import script from "./PopupNotificationGlobal.vue?vue&type=script&lang=ts&"
export * from "./PopupNotificationGlobal.vue?vue&type=script&lang=ts&"
import style0 from "./PopupNotificationGlobal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports